export default {
    AddAThirdPartyAfterSalesOrder: {
        Basic: '三方售后单基本信息',
        Third: '客户订单号',
        button: '请点击右侧按钮选择',
        Associate: '关联三方订单',
        channel: '选择渠道',
        store: '选择店铺',
        type: '售后类型',
        stage: '售后阶段',
        Application: '申请售后时间',
        After: '售后原因',
        sales: '三方售后单号',
        party: '三方换货单号',
        remarks: '售后备注',
        information: '买家售后信息',
        nickname: '买家昵称',
        Return: '退货物流公司',
        select: '请选择物流公司',
        document: '售后物流单号',
        Original: '原收件地址',
        Exchange: '换货收件人',
        phone: '换货收件手机',
        address: '换货收件地址',
        Detailed: '详细地址',
        product: '售后商品信息',
        products: '添加售后商品',
        item: '换货商品信息',
        Add: '添加换货商品',
        associated: '选择关联三方订单',
        Selectproducts: '选择售后的商品',
        Related: '关联三方订单：',
        SelectItem: '选择换货商品',
        number: '请选择关联客户订单号',
        antype: '请选择售后类型',
        thereason: '请选择售后原因',
        thenumber: '请输入三方售后单号',
        thestage: '请选择售后阶段',
        anorder: '请先选择关联三方销售单',
        addproducts: '请先添加售后商品',
        msgWarning: '退款金额不能大于交易金额！',
        anfirst: '请先选择关联三方订单',
        Are: '确定删除?',
        deleted: '删除成功',
        category: '退款类别',
        amount: '退款金额',
        Refundtype: '退款类型',
        message: '买家留言',
        Sellermessage: '卖家留言',
        Refundmethod: '退款方式',
        RefundID: '退款ID',
        Customer: '银行客户姓名',
        BSB: 'BSB',
        Bank: '银行账号',
        refundMsgTitle: '退款信息',
        evidence: '附件证据',

        form: {
            Original: '原始子订单号',
            Whether: '是否赠品',
            productID: '平台商品ID',
            productcode: '平台商品编码',
            PlatformID: '平台规格ID',
            Platformcode: '平台规格编码',
            Platformname: '平台商品名称',
            Product: '商品数量',
            commodity: '系统商品编码',
            SKU: '系统SKU编码',
            Unit: '商品单价',
            Transaction: '交易金额',
            Refund: '退款金额',
            Remarks: '备注',

            classification: '商品分类',
            // Productname: '商品名称',
            System: '系统商品编码',
            SKUCode: '系统SKU编码',
            quantity: '商品数量',
            Retail: '商品零售价',
        }
    }
};
